import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { LoadingBar } from '../../components/util/LoadingBar';
import { SliderControl } from '../../components/controls/NewSliderControl';
import Hint from '../../components/ModuleDrawer/Hint';
import { currencyFormatter } from '../../components/Money';
import { fetchJobsModule } from '../../actions/jobsActions';
import { fetchSpendingPlan, updateSpendingPlanData } from '../../actions/wealthManagementActions';
import { getCurrentAfterTaxIncome } from '../../actions/simulationActions';

export const STEP_SIZE = 250;

class RetirementAmountNeeded extends Component {
  constructor(props) {
    super(props);

    console.log(props);
    let goalExpensesInRetirement = 2500;
    if (props.spendingPlan && props.spendingPlan.retirement_budget) {
      goalExpensesInRetirement = props.spendingPlan.retirement_budget;
    }

    this.state = { goalExpensesInRetirement };
  }

  onChange = evt => {
    this.setState({ goalExpensesInRetirement: evt.detail.value });
  };

  componentDidMount() {
    const { dispatch, jobs, spendingPlan } = this.props;
    if (!jobs) {
      dispatch(fetchJobsModule());
    }
    // check if spending plan is loaded
    if (!spendingPlan) {
      dispatch(fetchSpendingPlan()).then(response => {
        // check if it has a value for retirement budget that will be applied in componentWillReceiveProps
        if (!response.retirement_budget) {
          dispatch(getCurrentAfterTaxIncome());
        }
      });
    }
  }

  componentWillReceiveProps = nextProps => {
    const { spendingPlan } = nextProps;
    // if we're getting a retirement_budget with new props when it was previously undefined
    if (this.props.spendingPlan && !this.props.spendingPlan.retirement_budget && spendingPlan.retirement_budget) {
      this.setState({
        goalExpensesInRetirement: spendingPlan.retirement_budget,
      });
    }
  };

  onSubmit = () => {
    // update spending plan module with new retirement_budget value and continue
    const { dispatch, onContinue } = this.props;
    const { goalExpensesInRetirement } = this.state;

    dispatch(updateSpendingPlanData({ retirement_budget: goalExpensesInRetirement })).then(onContinue);
  };

  render() {
    const { dashboard, jobs, onBack, onContinue, simulations, spendingPlan, wrapper } = this.props;
    const { goalExpensesInRetirement } = this.state;

    if (!jobs || !spendingPlan) {
      return <LoadingBar />;
    }

    let maxExpensesYearly = jobs.primary_base;
    if (dashboard.has_partner) {
      maxExpensesYearly += jobs.partner_base;
    }

    // round max monthly expenses in dollars to the nearest $`STEP_SIZE`, currently $250
    const maxExpensesMonthly = Math.round(maxExpensesYearly / 12 / STEP_SIZE) * STEP_SIZE;

    return (
      <DynamicWrapper
        wrapper={wrapper}
        canContinue
        onContinue={this.onSubmit}
        onBack={onBack}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <Text use="headline6">
          How much money will you {dashboard.has_partner ? 'and your spouse ' : ''} need in retirement?
        </Text>

        <Text use="subtitle1" className="pl-3 pr-3">
          Select the approximate amount in today's after-tax dollars. Try to include regular monthly expenses as well as
          one-off expenses like vacations averaged to a monthly amount.
        </Text>

        <div style={{ width: '80%' }}>
          <SliderControl
            spec={{
              field_type: 'range',
              min: 0,
              max: maxExpensesMonthly,
              step_size: STEP_SIZE,
              _default: 3000,
            }}
            onChange={this.onChange}
            onInput={this.onChange}
            value={this.state.goalExpensesInRetirement}
          />
        </div>
        <Text use="subtitle1">
          Monthly Expenses in Retirement:{' '}
          <span style={{ fontWeight: 500 }}>{currencyFormatter(goalExpensesInRetirement)}</span>
        </Text>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    jobs: state.modules.jobs.data,
    dashboard: state.modules.dashboard.data,
    simulations: state.simulations,
    spendingPlan: state.modules.spendingPlan.data,
  };
}

export default connect(mapStateToProps)(RetirementAmountNeeded);
